import React, {useEffect, useState} from 'react';
import './style.scss';
import {BottomNav, RatingBanner, RatingCard} from '../../components';
import {useCurrentUser} from '../../layouts/UserContext';
import profileCardDefault from '../../../images/profile-card-default.png';
import {CommonUtil} from '../../utils/CommonUtil';
import {RatingPrize1, RatingPrize2, RatingPrize3} from "./components";
import { telegramMock } from 'telegram.consts';
import axios from 'axios';

const webApp = window.Telegram.WebApp;

const NavBack = ({onClick}) => <svg
    className="app-rating--back"
    onClick={() => onClick()}
    width="24" height="24"
    viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M15 18L9 12L15 6" stroke="#9E9E9E" strokeWidth="1.6"/>
</svg>;

export const RatingPage = () => {
    const {user} = useCurrentUser();
    const [showPrizes, setShowPrizes] = useState(false);
    const [ratingUsers, setRatingUsers] = useState([]);
    const [myRatingUser, setMyRatingUser] = useState(null);

    useEffect(() => {
        CommonUtil().ymReachGoal('ladybug_game_view_rating');
        console.log('[Ladybug.Rating] > ready')
        axios.post("https://lovi-kwami.tv3.ru/api/ladybug-game/rating", {
            hash: user.authToken,
          }).then(response => {
            console.log('rating response', response);
                let _rs = 0;
                response.data.map(
                    ru => {
                        _rs += ru.score;
                        if (ru.active) {
                            setMyRatingUser(ru);
                        }
                    }
                )
                setRatingUsers(response.data);
            });
    }, []);

    useEffect(() => {
        console.log('rating users', ratingUsers);
    }, [ratingUsers]);

    return <div className="app-rating app-hide-scroll">
        {/* My own card */}
        {!showPrizes && user && <RatingCard
            key={'rating_card_me'}
            number={myRatingUser ? myRatingUser.position : ''}
            image={user.photo || profileCardDefault}
            title={((user.firstName || '') + ' ' + (user.lastName || '')).trim()}
            coins={user.coins}
            active={true}
            error={!user.chatMember}
        />}
        {!showPrizes && !user.chatMember && <div className="app-rating-card--warning">
            Хочешь, чтобы твои баллы сохранились в&nbsp;рейтинге?<br/>
            Просто подпишись на <a onClick={() => webApp.openTelegramLink('https://t.me/tv3russia')}>канал ТВ-3</a>, и&nbsp;ты&nbsp;в&nbsp;игре!&nbsp;😉
        </div>}

        {/* Rating */}
        {!showPrizes && <div className="app-rating--list">
            <h2>Рейтинг</h2>
            {/* <RatingBanner onClick={() => {
                CommonUtil().ymReachGoal('ladybug_game_click_banner_prizes');
                setShowPrizes(true);
            }}/> */}
            {ratingUsers.map(ratingUser => <RatingCard
                key={'rating_card_' + ratingUser.position}
                number={ratingUser.position}
                image={ratingUser.payload.photoPath || profileCardDefault}
                title={((ratingUser.payload.first_name || '') + ' ' + (ratingUser.payload.last_name || '')).trim()}
                coins={ratingUser.payload.score}
                active={ratingUser.active}
            />)}
        </div>}
        {!showPrizes && <BottomNav/>}

        {/* Prizes */}
        {showPrizes && <div className="app-rating--prizes">
            <header>
                <NavBack onClick={() => setShowPrizes(false)}/>
                <h2>Призы</h2>
            </header>
            <RatingPrize1/>
            <RatingPrize2/>
            <RatingPrize3/>
        </div>}
    </div>;
}